export const PROMOTIONAL_PROPERTIES = "/promotional-properties";
export const PROPERTY_VERIFICATION = `${PROMOTIONAL_PROPERTIES}/property-verification`;
export const CREATE_PROPERTY = `${PROMOTIONAL_PROPERTIES}/create`;
export const EDIT_PROPERTY = `${PROMOTIONAL_PROPERTIES}/edit/:id`;
export const COPY_PROPERTY = `${PROMOTIONAL_PROPERTIES}/copy/:id`;
export const INFLUENCER_ONBOARDING = "/influencer-onboarding";
export const INFLUENCER_DESCRIPTION = `${INFLUENCER_ONBOARDING}/description`;
export const INFLUENCER_USER_COMPANY = `${INFLUENCER_ONBOARDING}/user-company`;
